import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {IntroductionInfo} from "./subPages/IntroductionInfo";
import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";
import {useDispatch, useSelector} from "react-redux";
import {skeleton} from "../../../redux/slice/apiSlice";
import {getIntroduction, removeIntroductions} from "../../../api/lifecycle/introduction/IntroductionService";
import {ContentCategory} from "../../../constant/CodeSpecNum";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {changeProgressStatusValue, changeStatusNumericValue} from "../../../redux/slice/contentSlice";
import {handleActiveError} from "../../../components/sonner/ToastBasic";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

const DEFAULT_TABS = [
    {clicked: true, name: "기본정보"},
    {clicked: false, name: "이력관리"},
];

function IntroductionTab() {
    const {id} = useParams();
    const status = useSelector((state) => state.api.status);
    const statusNumericValue = useSelector((state) => state.content.statusNumericValue);
    const refresh = useSelector((state) => state.status.refreshContent);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tabs, setTabs] = useState(DEFAULT_TABS);
    const [introduction, setIntroduction] = useState({});

    useEffect(() => {
        setIntroduction({});
        setTabs(DEFAULT_TABS);
        dispatch(changeStatusNumericValue(0));
        dispatch(changeProgressStatusValue({}));
    }, [id, dispatch]);

    useEffect(() => {
        if (!id) return;

        let cancelled = false;
        dispatch(skeleton(true));

        Promise.all([
            getIntroduction(id),
            getContentStatus({contentId: id, contentCategory: ContentCategory.INTRODUCTION}),
        ])
            .then(([introductionResponse, progress]) => {
                if (cancelled) return;

                if (introductionResponse.status === 201) {
                    if (introductionResponse.data.errorCode === "AUTHORITY") {
                        alert(introductionResponse.data.reason);
                        navigate(-1);
                    }
                }

                if (introductionResponse.status === 200) {
                    setIntroduction(introductionResponse.data);
                } else if (introductionResponse.status === 201 || introductionResponse.status === 202) {
                    handleActiveError({
                        message: introductionResponse.data.title,
                        description: introductionResponse.data.reason,
                    });
                } else if (introductionResponse.response?.status === 401) {
                    alert("로그인이 필요합니다.");
                    navigate("/");
                } else if (introductionResponse.response?.status === 403) {
                    alert("권한이 없습니다.");
                    navigate("/");
                }

                if (progress.status === 200) {
                    dispatch(changeStatusNumericValue(progress.data.statusNumericValue));
                    dispatch(changeProgressStatusValue(progress.data));
                } else if (progress.status === 201 || progress.status === 202) {
                    handleActiveError({message: progress.data.title, description: progress.data.reason});
                }
            })
            .finally(() => {
                if (!cancelled) {
                    dispatch(skeleton(false));
                }
            });

        return () => {
            cancelled = true;
        };
    }, [id, status, refresh, dispatch, navigate]);

    if (Object.keys(introduction).length > 0) {
        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
                <DetailHeroSummaryProvider>
                    <DetailTabBar tabs={tabs} setTabs={setTabs} />
                    {tabs[0].clicked && (
                        <IntroductionInfo
                            id={id}
                            introduction={introduction}
                            statusNumericValue={statusNumericValue}
                        />
                    )}
                    {tabs[1].clicked && <CommonHistoryList id={id} tableName="자산도입관리" />}
                </DetailHeroSummaryProvider>
            </div>
        );
    }

    return null;
}

export {IntroductionTab};
